const isStaticRendering = (typeof(window) === 'undefined');

export {isStaticRendering}
